import { useParams } from 'react-router-dom';

import { PageWrap, Text } from '../../components';
import { useMyUserClient } from '../../hooks';
import Prose from './Prose';
import SectionDesignFileOrganisation from './sections/SectionDesignFileOrganisation';
import SectionDevelopmentWorkflow from './sections/SectionDevelopmentWorkflow';
import SectionMaintenanceTickets from './sections/SectionMaintenanceTickets';
import SectionQaReleasingToUsers from './sections/SectionQaReleasingToUsers';
import SectionSecurity from './sections/SectionSecurity';
import SectionThirdPartyServices from './sections/SectionThirdPartyServices';

export default function SectionPage() {
  const { slug } = useParams<{ slug: string }>();

  const myUser = useMyUserClient();
  if (!myUser.agencyRole) return null;

  function renderInner() {
    switch (slug) {
      case '3rd-party-services':
        return <SectionThirdPartyServices />;
      case 'development-workflow':
        return <SectionDevelopmentWorkflow />;
      case 'design-file-organisation':
        return <SectionDesignFileOrganisation />;
      case 'maintenance-tickets':
        return <SectionMaintenanceTickets />;
      case 'qa-releasing-to-users':
        return <SectionQaReleasingToUsers />;
      case 'security':
        return <SectionSecurity />;
      default:
        return <Text as="div">Not found</Text>;
    }
  }

  return (
    <PageWrap limitWidth="smaller">
      <Prose>{renderInner()}</Prose>
    </PageWrap>
  );
}
